import styled from '@emotion/styled'
import { keyframes } from '@emotion/css'

const blinkAnimation = keyframes`
  0% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.3; transform: scale(1.15); }
  100% { opacity: 1; transform: scale(1); }
`

export const BlinkingWrapper = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ef2605;
  animation: ${blinkAnimation} 1.2s infinite ease-in-out;
`

export const CardContainer = styled('div')`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 32px;
  width: 100%;
  position: relative;
  user-select: none;
`



export const Dot = styled('div')<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: ${(props) => props.color};
`

export const TableContainer = styled('div')`
  width: 100%;
  .ant-table-thead > tr > th {
    background: #fbfbfb !important;
    color: #666 !important;
    font-family: 'Prompt', sans-serif !important;
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 16px !important;
    text-transform: uppercase !important;
    letter-spacing: -0.4px !important;
  }
  .ant-table-tbody > tr > td {
    font-size: 12px !important;
  }
  .ant-table-tbody > tr.selected-row > td {
    background: #e6f6ea !important;
  }
  cursor: pointer;
`



export const UnrespondedCountBox = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 32px;
  margin-bottom: 32px;

  .label {
    font-size: 24px;
    font-weight: 700;
    color: #262626;
    text-align: center;
    margin-bottom: 16px;
  }

  .count {
    font-size: 96px;
    font-weight: 700;
    color: #ef2605;
    line-height: 1;
  }
`
